var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('h1',{staticClass:"page-title",attrs:{"data-title":"Paramètres"}},[_vm._v("Paramètres")]),_c('button',{staticClass:"btn",on:{"click":_vm.logout}},[_vm._v("Déconnexion")])])}
var staticRenderFns = []

export { render, staticRenderFns }